module.exports = __webpack_public_path__ + "22_kdd.jpg?fd49c18ccc1386b9803c44ea5baa1ecf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_kdd.jpg
// module id = 186
// module chunks = 0